module.exports = __webpack_public_path__ + "img/logo.8ab10329.png";